import React from 'react';
import { TWConfirmModal } from '../../../components/ui';

export default function ModalConfirmation({
  show,
  onClose,
  title,
  description,
  onSubmit,
  loading,
  buttonText = 'Confirm',
  cancelText = 'Cancel',
}) {
  return (
    <TWConfirmModal
      open={show}
      onClose={onClose}
      onConfirm={onSubmit}
      tone="warning"
      title={title}
      description={description}
      confirmLabel={buttonText}
      cancelLabel={cancelText}
      loading={loading}
    />
  );
}
